<template>
<div>
  <v-form
    class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Diagnosis</h3>
    <v-layout>

      <v-flex md2>
        <h4 class="text-left mb-5">
          <div v-if="running">
            <v-progress-circular indeterminate class="mx-2"></v-progress-circular>
            <span class="state">Running... </span>
          </div>
          <div v-else >
            <span class="mx-2">Diagnosis:</span>

            <span class="state ml-2">Done </span>
            <v-icon color="success">mdi-check-bold</v-icon>
          </div>
        </h4>
            <v-btn color="primary" :disabled="running" class="mr-2" @click="diagnosis()">run again</v-btn>
            <v-btn color="primary" :disabled="running" @click="copiar()" class="text-left">Copy</v-btn>
      </v-flex>
      <v-flex md10>
        <v-textarea
            background-color="rgba(255,255,255)"
            name="input-7-1"
            label="Response"
            no-resize
            height="550px"
            v-model="response"
            outlined
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</div>
</template>
<script>
  import { mapMutations } from 'vuex'
  import alisonJS from  '@/services/alison_js.js'
  export default  {
    data: () => ({
      valid:false,
      running:true,
      dialog: false,
      accessToken: '',
      validToken: false,
      requestPayload: "",
      response: "",
      v1_idx: '',
      v1_value: '',
      v2_idx: '',
      v2_value: '',
    }),
    mounted(){
      this.valid = false;
      this.accessToken = 'eyJ2ZXJzaW9uIjo0LCJ2MSI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6IjMvK0RKMmsxQS9yWjQxL0hlWllYS00ydG1XazE4cDM4RXg0WDdWTWZlYXhpS3dWUHZVRTZzaUh1aHplZThHU1RMR2FwUWRXaFJRNzlyQXRqeWpRWkYxeC83Rm1ZcERzVExnTTQzdDRlV2dMV2NaclQ2Sy9uRGwvc1ltRGtLZjBjWDFtc3JHbkM4RWNQNk9KQW04RGlhUG5ZVlR0ZUpaOVEzbVNJeDk2OGU0cnpJNlF6YUh2L09FQnVmUHhMbTdpMjhQS3JBbHdSS3BQZTFVc3c4eG45NjMxRlJWc1JxaEk1WGFoamRoV2RWQnRkRmg1bE51Y1BUUDVEbFQzdkJIZy94VmV5TllOdVcvRWFobUZiS2RSRS9IRmdEOFN0cnVPTTVvNXJLSHptc2xPbnJFSi8yQkdEa1AxcnF3Nm0wZnlZUTR6K2RpYzdlTHhLWnRsNUNGWGhBR0dLOEdIYXVJVGU5RWUrQUJjN3c1WC8zZkJKVDI4VTgyOEo1V0dOZ0t6TVo5akdsbzVLNVgxOEh1cHVvZ1BGSm9nVjkyV2llbmR5c2JXMmRiZXltcVNINDBTN2kvcDdLb2pRZ2ZyNWtveHl1ZFV1cmgvK1NuYXhYOEczMTF2THU0OUNIalpmdCtycXkvRFlUZFdRS3pYYTFHanZMME5zQkIyNTFRU01OdDdoLzFSYjJkdnNMVk5HcnNKR3BjNFhMWEx1a0J6V1pXSW4zeWd1cDZUMlR0SnhzZCtPSWhtVkxhZldNbHhNME03diJ9LCJ2MiI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6ImV5SmhiR2NpT2lKU1V6STFOaUo5LmV5SnBZWFFpT2pFM05EUXpNVEkyTURVc0ltVjRjQ0k2TVRnME56Y3pOakF3TUN3aVkyOXRjR0Z1ZVU1aGJXVWlPaUpEWlhKMGFWTjFjaUJUTGtFdUlpd2lZV3hzYjNkbFpFOXlhV2RwYm5NaU9sc2lLaTVqWlhKMGFYTjFjaTVqYjIwaUxDSXFMbU5sY25ScGMzVnlMbTVsZENJc0lpb3VZMlZ5ZEdsemRYSXVhVzVtYnlJc0lpb3VkbVZ5YVhOMWNpSXNJaW91ZEc5d2RISjFjM1F1WTI5dExtRnlJaXdpS2k1elpXTjFjbVZrYjJNdWJHRWlMQ0pqYUhKdmJXVXRaWGgwWlc1emFXOXVPaTh2YTNCcWJHRm5aR3B3WVdscGJXNWxZMlJpWkdOdVpHcGphV3B2WVd4aWJHRWlMQ0l4TWpjdU1DNHdMakU2T0RBd015SXNJakV5Tnk0d0xqQXVNVG80TURBMElpd2liRzlqWVd4b2IzTjBPamd3TURNaUxDSnNiMk5oYkdodmMzUTZPREF3TkNJc0lteHZZMkZzYUc5emRDNWpaWEowYVhOMWNpNXVaWFE2T0RBNE1DSmRmUS5Gc09hel9LRWJ2WFh1dkZldXVCWExNYU42dVNjcXF2akt2Vl94dnhrUjQ2eGxuMDZyWnhTby14NElHdjcxajN0dHpERWVXUkQzUTZyV1lfeTViajR3LS0wN1dGRnM4eE8zdVpDUVdfclh3enk5TTJ2bkxIRGdtc0IyNUFPYkhTUVY3QW9iNzRZYTJRcjdlMVFQZldGallpUjlMV3hlVGV0a2dpWTluV2U2MFRoNG5sZC1mbGJSbjVVVnExQ0hqTVBiR3llc0hmSktXSkxZN001NlRIN0pKTno2Q0FNTFIwQkRlSmpodUhJN2ktMkJ2MjRzMmREMFV4Q3ZXU1RJM1piODkyc2xQMVBFdHROWGpvU2tVWVotSlU0WU1GN2tSVDZabnZmR3ZYSjdPQXdnTTFvMFRjR0Q2NGt0bXVySk00dzJoVGZXUDd3SGxXNjFoNE1aamVRcmcifX0='
      this.updateRequest();
      this.diagnosis();
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async diagnosis(){
        this.response=""
        try {
          this.running = true
          const isRunning = await alisonJS.isRunning()
          if(isRunning){
            this.response = this.response + 'Alison desktop version: '+alisonJS.desktopVersion()
            const init = await alisonJS.initialize(JSON.parse(this.requestPayload))
            console.log("init:", init);
            //this.response = this.response + "\nAlison Sdk initialized..."
            const keystores = await alisonJS.listKeyStores()
            this.response = this.response + '\nKeyStores: \n'+ JSON.stringify(keystores.keyStores, null, "\t")
            console.log("keystores:", keystores);
            const certificates = await alisonJS.certificateList()
            this.response = this.response + '\nCertificates: \n'+ JSON.stringify(certificates.certificates, null, "\t")
            console.log("certiicates:", certificates)
            this.running = false
          }else {
            this.response = this.response + 'Alison desktop is not running!'
            this.running = false
          }
        } catch (error) {
          this.response = this.response + JSON.stringify(error)
          this.running = false
        }
      },
      updateRequest(){
        this.requestPayload = JSON.stringify({ accessToken: this.accessToken}, null, "\t")
      },
        copiar() {
          var aux = document.createElement("input");
          aux.setAttribute("value", this.response);
          document.body.appendChild(aux);
          aux.select();
          document.execCommand("copy");
          document.body.removeChild(aux);
          this.setColor('info')
          this.setSnack('Copied to clipboard')
        }
    },
  }
</script>
<style scoped>
.state{
  font-weight: 300;
}
.title{
  font-size: 18px;
}
</style>
